import { batch } from 'react-redux';

import { clearErrors } from './ErrorActions';
import { clearWarnings } from './WarningActions';
import { selectSessionExpirationErrorCode } from '../selectors/AuthSelectors';

export const filterOutErrorsExceptTokenExpired = (sessionExpirationErrorCode) => ({ code }) =>
  code === sessionExpirationErrorCode || code === '50001';

export function clearFormErrorsAndWarnings() {
  return (dispatch, getState) => {
    const sessionExpirationErrorCode = selectSessionExpirationErrorCode(getState());

    batch(() => {
      dispatch({
        type: 'CLEAR_FORM_ERRORS_AND_WARNINGS',
      });
      dispatch(clearWarnings());
      dispatch(clearErrors(filterOutErrorsExceptTokenExpired(sessionExpirationErrorCode)));
    });
  };
}
